module.exports = __webpack_public_path__ + "img/img3.b2ebc54e.jpg";